const getLink = (token: string) => `${window.location.origin}/invite/${token}`;

export const invitesUtils = {
  getLink,
};
